/**
 * @generated SignedSource<<d19a8337007e95deeccadefa2e4c1cf5>>
 * @relayHash 2285bb60c1ae5119fa7ec8791454499a
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-nft/572.0.0-2026-08-11T14:53:16.313Z/NftPublicProfileReportModalMutation

import { ConcreteRequest } from 'relay-runtime';
export type PublicProfileReportInput = {
  additionalInfo?: string | null;
  clientMutationId?: string | null;
  username: string;
};
export type NftPublicProfileReportModalMutation$variables = {
  input: PublicProfileReportInput;
};
export type NftPublicProfileReportModalMutation$data = {
  readonly publicProfileReport: {
    readonly __typename: "PublicProfileReportPayload";
  } | null;
};
export type NftPublicProfileReportModalMutation = {
  response: NftPublicProfileReportModalMutation$data;
  variables: NftPublicProfileReportModalMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "PublicProfileReportPayload",
    "kind": "LinkedField",
    "name": "publicProfileReport",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "NftPublicProfileReportModalMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutations",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "NftPublicProfileReportModalMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "id": "app-buyer-nft/572.0.0-2026-08-11T14:53:16.313Z/NftPublicProfileReportModalMutation",
    "metadata": {},
    "name": "NftPublicProfileReportModalMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "cc8b7c8d41dd0e375a6241271a95ff9e";

export default node;
